<template>
  <div>
    <v-btn class="my-3 ml-3" @click="sendFiles" color="warning">Закрепить и отправить документы</v-btn>
    <v-row>
      <v-col cols="12">
        <v-tabs
          grow
          centered
          show-arrows
          v-model="tab"
        >
          <v-tab
            v-for="file in files"
            :key="file.name"
            :href="'#' + file.name"
          >
            {{ file.title }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-tabs-items v-model="tab">
          <v-tab-item :value="tab">
            <v-expansion-panels class="ml-2" focusable flat tile :key="'attachmentsPanel:' + tab">
              <v-expansion-panel v-for="attachment in selectedGroup" :key="attachment.name" class="mt-2">
                <v-expansion-panel-header color="grey lighten-4">
                  <div>{{ attachment.title }}</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="py-3">
                  <h4 class="font font--color_light mb-2">Загрузите документы</h4>
                  <AttachmentUpload
                    class="max-height: 90px"
                    multi
                    :name="attachment.name"
                    :value="attachment.files"
                    :allowed-types="(attachment.properties || {}).allowed_extensions"
                    :group-name="tab"
                    :context-id="appId"
                    context-name="app"
                    @attachment-file-add="updateFiles"
                    @attachment-file-remove="updateFiles"
                  >
                    <template #list-prepend>
                      <v-divider class="mt-3"></v-divider>
                      <h4 v-if="attachment.files && attachment.files.length !== 0" class="font font--color_light my-2">Загруженные документы</h4>
                    </template>
                  </AttachmentUpload>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-data-table
      v-if="sharepoint && sharepoint.data"
      class="mt-4"
      :headers="[{
        text: 'Категория',
        value: 'title'
      }]"
      :items="sharepoint.data"
      :items-per-page="-1"
      disable-sort
      hide-default-footer
      show-expand
    >
      <template #top>
        <span class="text-caption">Загруженные файлы в SharePoint</span>
      </template>

      <template #expanded-item="{ item }">
        <v-list>
          <v-list-item
            v-for="file in item.files"
            :key="`${item.type}-${item.id}-${file.id}`"
          >
            <v-list-item-content>
              <v-list-item-title
                class="text-subtitle-2"
                :title="file.relativeUrl"
                v-text="file.title"
              ></v-list-item-title>
              <v-list-item-subtitle
                class="text--secondary"
                :title="file.timeCreated"
                v-text="new Date(file.timeCreated).toLocaleString('ru')"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon :href="sharepoint.baseUrl + file.relativeUrl" target="_blank" rel="noopener">
                <v-icon color="accent">mdi-chevron-double-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AttachmentUpload from "@/components/common/AttachmentUpload";

export default {
  name: "AppDocument",

  components: {
    AttachmentUpload
  },

  data() {
    return {
      tab: null,
      files: null,
      selectedGroup: [],
      id: null,
    };
  },

  watch: {
    attachments(e) {
      this.files = e;
    },
    tab(e) {
      this.selectedGroup = this.attachments?.find(item => item.name === e)?.list ?? [];
    },
  },

  mounted() {
    this.files = this.attachments;
  },

  methods: {
    ...mapActions("app", ["appInfo", "appTouch"]),

    updateFiles({ groupName, name, updatedList }) {
      this.$store.commit("app/setAttachmentListFiles", { groupName: groupName, name, value: updatedList });
    },

    sendFiles() {
      this.appTouch();
    },
  },

  computed: {
    ...mapGetters("app", ["attachments", "extra"]),
    ...mapState("app", ["appId"]),

    sharepoint() {
      return this.extra?.sharepoint;
    }
  },
};
</script>

<style lang="scss" scoped>
  .v-tab {
    font-size: 0.8em;
  }
</style>
